import React, { ReactElement } from 'react';

import { IShopifyApp } from '../../shared/types/IShopifyAppData';
import { FooterTestIds } from '../FooterTestIds';

export function OmazeLogo (): ReactElement {
    const shopify: IShopifyApp = window.ozShopifyApp;

    return (
        <a href="https://www.omaze.com" data-testid={FooterTestIds.OMAZE_LOGO}>
            <img src={shopify.assets.omazeLogoUrl} alt="OmazeLogo" />
        </a>
    );
}
